// The camera asks for 1920x1920 at JPEG quality 0.92. Re-encoding real photos
// at 1280px and 0.7 made them 4.7x smaller
export const PHOTO_MAX_EDGE = 1280;
export const PHOTO_QUALITY = 0.7;

/**
 * Re-encodes a photo as a JPEG no larger than `maxEdge` on either side. Falls
 * back to the original whenever re-encoding fails or would not make it
 * smaller, so a photo is never lost
 */
export const downscalePhoto = (
  dataUrl: string,
  maxEdge = PHOTO_MAX_EDGE,
  quality = PHOTO_QUALITY
): Promise<string> =>
  new Promise((resolve) => {
    const image = new Image();
    image.onload = () => {
      try {
        const scale = Math.min(
          1,
          maxEdge / Math.max(image.naturalWidth, image.naturalHeight)
        );
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(image.naturalWidth * scale);
        canvas.height = Math.round(image.naturalHeight * scale);

        const context = canvas.getContext("2d");
        if (!context) {
          resolve(dataUrl);
          return;
        }
        context.imageSmoothingQuality = "high";
        context.drawImage(image, 0, 0, canvas.width, canvas.height);

        // browsers that can't encode JPEG hand back a PNG, and an empty
        // canvas gives "data:,", neither of which is worth keeping
        const resized = canvas.toDataURL("image/jpeg", quality);
        resolve(
          resized.startsWith("data:image/jpeg") &&
            resized.length < dataUrl.length
            ? resized
            : dataUrl
        );
      } catch {
        resolve(dataUrl);
      }
    };
    image.onerror = () => resolve(dataUrl);
    image.src = dataUrl;
  });
